// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3yfAR","col":"Table_col__2rRqC","fulfillmentStatus":"Table_fulfillmentStatus__3vX8y","emailCol":"Table_emailCol__3K9Ii"};